<template>
  <div>
    <v-card flat>
      <v-card-text>
        <template v-if="type === 'medicalclinic'">
          <user-profile-lab
            :patient="data"
            :patientinfo="data"
            :useData="useData"
          ></user-profile-lab>
        </template>
        <template v-else>
          <user-profile :patientinfo="patientinfo" :data="data" :useData="useData" />
        </template>
        <v-row style="margin-top: 1rem">
          <v-col class="box" cols="12" style="margin-top: 1rem; background-color: white">
            <v-form v-model="valid" class="position-relative">
              <block v-if="loading"></block>

              <v-row class="ml-2 mr-2" style="margin-top: 0.3rem">
                <v-col cols="12" class="tabsNh">
                  <v-col
                    v-if="medication.length > 0 && rightTableUniqueParameter == 'ID_VPMP'"
                    cols="12"
                    style="display: flex; justify-content: space-between"
                  >
                    <div style="width: 293px;">
                      <v-btn
                        small
                        v-if="$store.getters['rolesUser/getCustomRole'](165)"
                        @click.prevent="
                          showAlert(
                            'question',
                            'Eiminar',
                            '¿Está seguro de eliminar este registro?',
                            'ConfirmDelete'
                          )
                        "
                        color="error"
                      >
                        <v-icon> mdi-delete </v-icon>
                      </v-btn>
                    </div>

                    <div>
                        <v-btn v-if="$store.getters['rolesUser/getCustomRole'](107)" small class="btn-save mr-1" @click.prevent="showBillPatient = true">
                            <v-icon class="mr-3">mdi-account-details</v-icon> Facturar paciente
                        </v-btn>
                    </div>

                    <div>
                      <v-btn
                        v-if="$store.getters['rolesUser/getCustomRole'](167)"
                        small
                        @click="showVacc = true"
                        style="margin-right: 0.3rem"
                        class="btnblue"
                      >
                        <v-icon class="mr-1">mdi-archive-clock</v-icon>
                        Vencimiento
                      </v-btn>
                      <v-btn
                        small
                        v-if="$store.getters['rolesUser/getCustomRole'](166)"
                        @click="
                          print = {
                            show: true,
                            data: {
                              date: date,
                              medication: medication,
                              patientinfo: patientinfo,
                              useData: useData,
                              customer: patientinfo.customer,
                            },
                          }
                        "
                        style="margin-right: 0.3rem"
                      >
                        <v-icon> mdi-printer </v-icon>
                      </v-btn>
                      <v-btn
                        small
                        class="btnblue mr-1"
                        @click="showhistory = !showhistory"
                        v-if="$store.getters['rolesUser/getCustomRole'](164)"
                      >
                        <v-icon> mdi-magnify </v-icon>
                      </v-btn>
                      <v-btn small class="btncleanVet mr-1" @click.prevent="resetData">
                        <v-icon> mdi-broom </v-icon>
                      </v-btn>

                      <v-btn
                        small
                        v-if="$store.getters['rolesUser/getCustomRole'](171)"
                        class="btn-save"
                        @click.prevent="updateVeterinaryParameterData"
                      >
                        <v-icon> mdi-content-save </v-icon>
                      </v-btn>
                    </div>
                  </v-col>

                  <v-col
                    v-else-if="
                      medication.length > 0 &&
                      rightTableUniqueParameter == 'ID_Plan_Perameter'
                    "
                    cols="12"
                    style="display: flex; justify-content: space-between"
                  >

                    <div style="width: 293px;" ></div>
                    <div>
                        <v-btn v-if="$store.getters['rolesUser/getCustomRole'](107)" small class="btn-save mr-1" @click.prevent="showBillPatient = true">
                            <v-icon class="mr-3">mdi-account-details</v-icon> Facturar paciente
                        </v-btn>
                    </div>

                    <div>
                      <v-btn
                        small
                        @click="showVacc = true"
                        style="margin-right: 0.3rem"
                        class="btnblue"
                        v-if="$store.getters['rolesUser/getCustomRole'](167)"
                      >
                        <v-icon class="mr-1">mdi-archive-clock</v-icon>
                        Vencimiento
                      </v-btn>
                      <v-btn
                        small
                        v-if="$store.getters['rolesUser/getCustomRole'](166)"
                        @click="
                          print = {
                            show: true,
                            data: {
                              date: date,
                              medication: medication,
                              patientinfo: patientinfo,
                              useData: useData,
                              customer: patientinfo.customer,
                            },
                          }
                        "
                        style="margin-right: 0.3rem"
                      >
                        <v-icon> mdi-printer </v-icon>
                      </v-btn>
                      <v-btn small class="btnblue mr-1" @click="showhistory = !showhistory" v-if="$store.getters['rolesUser/getCustomRole'](164)">
                        <v-icon> mdi-magnify </v-icon>
                      </v-btn>

                      <v-btn small class="btncleanVet mr-1" @click.prevent="resetData">
                        <v-icon> mdi-broom </v-icon>
                      </v-btn>
                      <v-btn
                        small
                        :class="medicationChecked ? 'btnsave' : 'btn-save-disabled'"
                        :disabled="!medicationChecked"
                        @click.prevent.stop="SaveMedication"
                        v-if="$store.getters['rolesUser/getCustomRole'](171)"
                      >
                        <v-icon> mdi-content-save </v-icon>
                      </v-btn>
                    </div>
                  </v-col>

                  <v-col
                    v-else-if="
                      !(
                        medication.length > 0 && rightTableUniqueParameter == 'ID_VPMP'
                      ) &&
                      !(
                        medication.length > 0 &&
                        rightTableUniqueParameter == 'ID_Plan_Perameter'
                      )
                      || !medicationChecked
                    "
                    cols="12"
                    style="display: flex; justify-content: space-between"
                  >

                    <div style="width: 293px;" ></div>
                    <div>
                        <v-btn v-if="$store.getters['rolesUser/getCustomRole'](107)" small class="btn-save mr-1" @click.prevent="showBillPatient = true">
                            <v-icon class="mr-3">mdi-account-details</v-icon> Facturar paciente
                        </v-btn>
                    </div>
                    
                    <div>
                      <v-btn
                        small
                        @click="showVacc = true"
                        style="margin-right: 0.3rem"
                        class="btnblue"
                        v-if="$store.getters['rolesUser/getCustomRole'](167)"
                      >
                      <v-icon class="mr-1">mdi-archive-clock</v-icon>
                        Vencimiento
                      </v-btn>
                      <v-btn
                        class="mr-1"
                        small
                        v-if="$store.getters['rolesUser/getCustomRole'](166)"
                        @click="
                          print = {
                            show: true,
                            data: {
                              date: date,
                              medication: medication,
                              patientinfo: patientinfo,
                              useData: useData,
                              customer: patientinfo.customer,
                            },
                          }
                        "
                      >
                        <v-icon> mdi-printer </v-icon>
                      </v-btn>
                      <v-btn small class="btnblue mr-1" @click="showhistory = !showhistory" v-if="$store.getters['rolesUser/getCustomRole'](164)">
                        <v-icon> mdi-magnify </v-icon>
                      </v-btn>
  
                      <v-btn small class="btnclean" @click.prevent="resetData">
                        <v-icon> mdi-broom </v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-col>
                <v-col cols="12" md="2" sm="12" style="margin-top: 1rem">
                  <date-picker
                    label="Fecha de aplicación / creación"
                    @dateSelected="
                      (param) => {
                        date = param;
                        plan.MedicationsDate = param;
                      }
                    "
                    v-model="date"
                  ></date-picker>
                </v-col>

                <v-col cols="6" md="2" style="margin-top: 1rem">
                  <v-text-field label="Peso" dense outlined v-model="weight" @change="changeWeight"></v-text-field>
                </v-col>
                <v-col cols="6" md="2" style="margin-top: 1rem">
                  <v-select outlined dense attach @change="switchWeightUnit" v-model="weightunit" :items="['Kg', 'Lb']" label="Unidad de peso"></v-select>
                </v-col>
                <v-col cols="12" md="7" sm="12"> </v-col>

                <v-col
                  cols="12"
                  md="1"
                  style="display: flex; justify-content: flex-end; margin-top: 0.5rem"
                >
                  <v-btn
                    @click="showComments = !showComments"
                    :class="plan.Comment ? 'btnclean' : 'btnblack'"
                  >
                    Comentarios
                  </v-btn>
                </v-col>

                <v-col cols="12" md="4">
                  <!--  <v-text-field outlined dense  disabled v-model="plan.PlanName"  label="Plantilla seleccionada"></v-text-field> -->
                </v-col>
                <v-col cols="12" md="6">
                  <!--  <template>
                            <v-btn
                          class="btn-save"
                          @click.prevent="plansDialog = !plansDialog"
                          right
                        >
                        Seleccionar Plantilla de medicación/vacunacion
                        </v-btn>
                          &nbsp;
                  
                        </template> -->
                </v-col>
              </v-row>

              

              <!--v-btn @click.prevent="">
                    <v-icon> mdi-mail </v-icon>
                  </v-btn>
                  &nbsp;
                  <v-btn dark color="green" @click.prevent="">
                    <v-icon> mdi-whatsapp </v-icon>
                  </v-btn>
                  &nbsp;
                  <v-btn @click.prevent="">
                    <v-icon> mdi-file-excel </v-icon>
                  </v-btn>
                  &nbsp;
                  <v-btn @click.prevent="">
                    <v-icon> mdi-xml </v-icon>
                  </v-btn>
                  &nbsp;
                  <v-btn @click.prevent="">
                    <v-icon> mdi-file-pdf-box </v-icon>
                  </v-btn-->

              <v-col cols="12" md="12">
                <v-col cols="12" style="display: flex; justify-content: flex-end">
                  <!-- <v-btn
                    v-if="plan.PlanName"
                        class="btn-save"
                        @click.prevent.stop="()=>{ showAllMedication = false ;medicationDialog = !medicationDialog}"
                        right

                      >
                       Agregar Medicamentos o Vacunas de plantilla
                  </v-btn> -->
                  &nbsp;
                  <v-btn
                    class="btn-save"
                    @click.prevent.stop="
                      () => {
                        showAllMedication = true;
                        medicationDialog = !medicationDialog;
                      }
                    "
                  >
                    Agregar Medicamentos o Vacunas
                  </v-btn>
                </v-col>
              </v-col>
              <v-col cols="12" style="margin-bottom: 1.2rem">
                <DxDataGrid width="100%"
               :scrolling="{useNative:true}"
                  :show-borders="true"
                  :data-source="medication"
                  key-expr=""
                  :onRowRemoving="handleRowDeleting"
                  @row-updated="UpdateRow"
                >
                  <DxEditing
                    :allow-updating="true"
                    :allow-deleting="false"
                    :confirmDelete="false"
                    :select-text-on-edit-start="true"
                    start-edit-action="click"
                    mode="cell"
                    :use-icons="true"
                  />
                  <DxColumn
                    :width="80"
                    cell-template="applicationTemplate"
                    header-cell-template="applicationHeader"
                    :allow-editing="false"
                  />
                  <DxColumn
                    :width="80"
                    cell-template="reminderTemplate"
                    header-cell-template="reminderHeader"
                    :allow-editing="false"
                  />
                  <DxColumn
                    :width="100"
                    :allow-editing="true"
                    caption="Orden"
                    data-field="Order"
                  />
                  <!--DxColumn
                  :width="30"
                    :allow-editing="false"
                    data-type="boolean"
                    data-field="checkbox"
                    header-cell-template="headerId"
                  ></DxColumn-->
                  <DxKeyboardNavigation
                    :edit-on-key-press="true"
                    enter-key-action="moveFocus"
                    enter-key-direction="column"
                  />
                  <DxColumn
                    data-field="Medicine"
                    :allow-editing="false"
                    header-cell-template="headerVaccines"
                    :width="350"
                  ></DxColumn>
                  <DxColumn
                    :width="100"
                    data-field="PeriodTime"
                    header-cell-template="headerPeriodTime"
                    data-type="number"
                  ></DxColumn>
                  <DxColumn
                  :width="columnWidth"
                    cell-template="periodUnit-selection"
                    header-cell-template="headerUnitPeriod"
                  >
                  </DxColumn>
                  <DxColumn
                    :width="250"
                    cell-template="periodTemplate"
                    caption="Períodos predefinidos"
                  />
                  <DxColumn
                  :width="columnWidth"
                    data-field="NextTime"
                    caption="Proxima vez"
                    data-type="date"
                    :allow-editing="false"
                    header-cell-template="headernextTime"
                  ></DxColumn>
                  <DxColumn
                  :width="columnWidth"
                    header-cell-template="headerItem"
                    cell-template="ItemType"
                    :allow-editing="false"
                  />
                  <DxColumn
                    :width="130"
                    header-cell-template="headerRecordType"
                    cell-template="RecordType"
                    :allow-editing="false"
                  />
                  <DxColumn
                    :width="60"
                    cell-template="deleteTemplate"
                    :allow-editing="false"
                  />

                  <template #periodUnit-selection="{ data }">
                    <span class="scroll-fixing-purchase">
                      <select
                        class="form-control custom-select"
                        v-model="data.data.PeriodUnit"
                        @change="handleMed"
                      >
                        <option v-for="item in items" :value="item.Name" :key="item.ID">
                          {{ item.NameESP }}
                        </option>
                      </select>
                    </span>
                  </template>
                  <template #applicationTemplate="{ data }">
                    <div class="record-type-cell">
                      <v-checkbox
                        :input-value="data.data.checkbox && !isReminderValue(data.data.IsReminder)"
                        class="pt-0"
                        @change="setRowRecordType(data.data, false, $event)"
                      ></v-checkbox>
                    </div>
                  </template>
                  <template #reminderTemplate="{ data }">
                    <div class="record-type-cell">
                      <v-checkbox
                        :input-value="data.data.checkbox && isReminderValue(data.data.IsReminder)"
                        class="pt-0"
                        @change="setRowRecordType(data.data, true, $event)"
                      ></v-checkbox>
                    </div>
                  </template>
                  <template #applicationHeader>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="record-type-heading" v-bind="attrs" v-on="on">
                          <v-icon small color="primary">mdi-needle</v-icon>
                        </div>
                      </template>
                      <span>Vacuna o medicamento pendiente de aplicar o administrar.</span>
                    </v-tooltip>
                  </template>
                  <template #reminderHeader>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="record-type-heading" v-bind="attrs" v-on="on">
                          <v-icon small color="primary">mdi-bell-outline</v-icon>
                        </div>
                      </template>
                      <span>Recordatorio para una fecha futura.</span>
                    </v-tooltip>
                  </template>
                  <template #periodTemplate="{ data }">
                    <span class="scroll-fixing-purchase">
                      <select
                        class="form-control custom-select width-90"
                        v-model="data.data.FullPeriod"
                        @change="setPeriod(data)"
                      >
                        <option value="" disabled selected>Selecciona un período</option>
                        <option v-for="period in periods" :value="period.value" :key="period.id">
                          {{ period.name }}
                        </option>
                      </select>
                    </span>
                  </template>
                  <template #headerPeriodTime>
                    <div>
                      Período
                    </div>
                  </template>
                  <template #headerUnitPeriod>
                    <div>
                      Unidad de <br />
                      tiempo
                    </div>
                  </template>
                  <template #headerItem>
                    <div
                      style="display: flex; align-items: center; justify-content: center"
                    >
                      <div style="margin-top: 0.5rem">Tipo</div>
                    </div>
                  </template>
                  <template #ItemType="{ data }">
                    <div>
                      <label v-if="data.data.ItemType == 'VAC'">Vacuna</label>
                      <label v-if="data.data.ItemType == 'MED'">Medicamento</label>
                    </div>
                  </template>
                  <template #RecordType="{ data }">
                    <v-chip v-if="data.data.checkbox" x-small :color="data.data.IsReminder ? 'orange' : 'green'" dark>
                      {{ isReminderValue(data.data.IsReminder) ? 'Recordatorio' : 'Próxima aplicación' }}
                    </v-chip>
                  </template>
                  <template #deleteTemplate="{ data }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          color="error"
                          title="Eliminar registro"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop.prevent="deleteMedicationRow(data.data)"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar registro</span>
                    </v-tooltip>
                  </template>
                  <template #headerRecordType>
                    <div>Registro</div>
                  </template>
                  <template #headernextTime>
                    <div>
                      Próxima <br />
                      Vez
                    </div>
                  </template>
                  <template #headerId>
                    <div
                      style="display: flex; align-items: center; justify-content: center"
                    >
                      <div style="margin-top: 0.5rem">ID</div>
                    </div>
                  </template>
                  <template #headerVaccines>
                    <div
                      style="display: flex; align-items: center; justify-content: center"
                    >
                      <div style="margin-top: 0.5rem">Medicamentos / Vacunas</div>
                    </div>
                  </template>
                </DxDataGrid>
              </v-col>
              <v-col style="margin-bottom: 1rem"> </v-col>
              <!-- <v-col cols="12">
                  <v-col  v-if="
                           medication.length > 0 &&
                          rightTableUniqueParameter == 'ID_VPMP'
                        " cols="12" style="display: flex; justify-content: space-between;margin-bottom: 1rem;">
                    <v-btn
                  
                        @click.prevent=' showAlert("question","Eiminar" ,"¿Está seguro de eliminar este registro?","ConfirmDelete");'
                      class="btndelete"
                    >
                    Eliminar registro
                    </v-btn>
                  
                      <v-btn
                        class="btn-save"
                  
                        @click.prevent="updateVeterinaryParameterData"
                      >
                       Guardar Registro
                      </v-btn>
                  </v-col>
                </v-col>
                <v-col cols="12">
                  <v-col  v-if="
                          medication.length > 0 &&
                          rightTableUniqueParameter == 'ID_Plan_Perameter'
                        " cols="12" style="display: flex; justify-content: flex-end; margin-bottom: 1rem;">
                    <v-btn
                        class="btn-save"
                        @click.prevent.stop="SaveMedication"
                  
                      >
                       Agregar Registro
                      </v-btn>
                    </v-col>
                </v-col> -->
            </v-form>
          </v-col>
        </v-row>
        <br />
        <UpcomingVaccinesModal
          v-model="showVacc"
          :patient="data"
        />

        <v-dialog v-model="plansDialog" scrollable max-width="700">
          <MedicationPlanPopUp @closePlan="closePlan($event)"></MedicationPlanPopUp>
        </v-dialog>
        <v-dialog v-model="medicationDialog" scrollable v-if="plan" width="80%" :key="reloadMed">
          <VaccineListPopUp
            :PlanId="plan.ID_Medication_Plan"
            :species="patientinfo.species"
            @closeMedic="closeMedicPopUp($event)"
            :medicationDialog="medicationDialog"
            :GetALL="showAllMedication"
            :PatientMedic="medication"
            :key="reloadMed"
          ></VaccineListPopUp>
        </v-dialog>
        <v-dialog v-model="deleteDialog" v-if="deleteHeader" max-width="500">
          <DeleteUserDialog
            :data="deleteHeader"
            :name="deleteHeader.PlanName"
            :v-if="deleteDialog"
            @close="
              deleteDialog = false;
              deleteHeader = null;
              getHeaderData();
            "
            @f_call="deleteVeterinaryHeader($event)"
          ></DeleteUserDialog>
        </v-dialog>
        <MedicationVaccines :data="print"></MedicationVaccines>
        <alerts
          v-if="alert.show"
          v-on:close_alert="closeAlert"
          v-on:accept_alert="acceptAlert"
          :properties="alert"
        ></alerts>
      </v-card-text>
      <v-dialog v-model="showhistory" :width="'90%'" scrollable>
        <v-card class="pa-4">
          <div class="history-dialog-header">
            <v-card-title class="text-h6 pa-0 font-weight-bold">
              HISTORIAL DE MEDICAMENTOS Y VACUNAS
            </v-card-title>
            <div class="history-dialog-actions">
              <v-btn
                small
                class="btnblue"
                title="Refrescar historial"
                @click.prevent="getHeaderData"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn small class="btndelete" title="Cerrar" @click.prevent="showhistory = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <v-card-text>
            <GeneralFilter
              entity="vacuna medicamento"
              :filterEndpoint="$API.veterinarymedication.filterVeterinaryMedicationHeader"
              :search="search"
              @emptyFilter="getHeaderData"
              @filtered="filterHandler"
            >
              <DxDataGrid
                class="isScrolledByGeneralFilter"
                :show-borders="true"
                :data-source="medicationsHeader"
                key-expr=""
                @exporting="onExporting"
                :column-auto-width="true"
                style="width: fit-content;"
              >
                <DxExport :enabled="true" />
                <DxPaging :page-size="10" />
                <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
                <DxColumn data-field="MedicationsDate" caption="Fecha" :min-width="100"></DxColumn>
                <DxColumn data-field="Weight" caption="Peso" :min-width="100"></DxColumn>
                <!-- <DxColumn data-field="PlanName" caption="Plantilla"></DxColumn> -->
                <DxColumn data-field="FullName" caption="Atendido por" :min-width="200"></DxColumn>
                <DxColumn data-field="Medications" caption="Medicamentos / Vacunas" :min-width="300" cssClass="left-align"></DxColumn>
                <DxColumn data-field="IsReminder" caption="Tipo" cell-template="historyType" :width="120"></DxColumn>
                <DxColumn
                  v-if="$store.getters['rolesUser/getCustomRole'](165)"
                  cell-template="show-delete"
                  :width="80"
                  caption=""
                ></DxColumn>
                <template #show-template="{ data }">
                  <div>
                    <a
                      href="#"
                      @click.prevent.stop="
                        getVeterinaryDetails(data.data);
                        deleteHeader = data.data;
                        showhistory = false;
                      "
                    >
                      <v-icon color="primary">mdi-eye</v-icon>
                    </a>
                  </div>
                </template>
                <template #show-delete="{ data }">
                  <div>
                    <a
                      href=""
                      class="mx-2"
                      @click.prevent.stop="
                        deleteHeader = data.data;
                        showAlert(
                          'question',
                          'Eiminar',
                          '¿Está seguro de eliminar este registro?',
                          'ConfirmDelete'
                        );

                        showhistory = false;
                      "
                    >
                      <v-icon color="error">mdi-delete</v-icon>
                    </a>
                  </div>
                </template>
                <template #historyType="{ data }">
                  {{ isReminderValue(data.data.IsReminder) ? 'Recordatorio' : 'Aplicación' }}
                </template>
              </DxDataGrid>
            </GeneralFilter>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>

    <!-- Dialog bill patient -->
    <VeterinaryBillingPanel v-model="showBillPatient" :customer-id="data && data.ID_Customer ? data.ID_Customer : (customer && customer.ID_Customer ? customer.ID_Customer : null)" />
    <!-- Dialog bill patient -->


    <v-dialog v-model="showComments" max-width="60%">
      <v-card class="pa-4">
        <div
          style="
            margin-top: 0.3rem;
            margin-bottom: 0.3rem;
            display: flex;
            justify-content: flex-end;
          "
        >
          <v-btn small class="btndelete" @click.prevent="showComments = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-col cols="12" md="12" style="">
          <quill-editor v-model="plan.Comment"></quill-editor>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Block from "@/components/Block";
import { DxDataGrid, DxColumn, DxPaging, DxEditing, DxKeyboardNavigation, DxExport } from "devextreme-vue/data-grid";
import DatePicker from "../../../components/DatePicker";
import MedicationPlanPopUp from "../../../components/VeterinaryMedication/MedicationPlanList.vue";
import VaccineListPopUp from "../../../components/VeterinaryMedication/MedicationList.vue";
import DeleteUserDialog from "../../settings/business/partial/DeleteTemplateDialog.vue";
import alerts from "@/components/Alerts";
import MedicationVaccines from "../../../components/ReportsAndPrintings/MedicatinVaccines.vue";
import { mapState } from "vuex";
import GeneralFilter from "@/components/GeneralFilter.vue";
import { printToExcel } from "@/helpers/printToexcel";
import UserProfile from "@/components/Displays/UserProfileDisplay.vue";
import UserProfileLab from "@/components/Displays/UserProfileDisplayLab.vue";
import { numberWithCommas } from "@/helpers/money";
import VeterinaryBillingPanel from "@/components/veterinary/VeterinaryBillingPanel.vue";
import UpcomingVaccinesModal from "@/components/veterinary/UpcomingVaccinesModal.vue";

export default {
  name: "VeterinaryMedications",
  components: {
    VeterinaryBillingPanel,
    UpcomingVaccinesModal,
    MedicationVaccines,
    alerts,
    DxDataGrid, 
    DxColumn, 
    DxEditing, 
    DxPaging, 
    UserProfile,
    UserProfileLab,
    //  DxLookup,
    DatePicker,
    Block,
    MedicationPlanPopUp,
    VaccineListPopUp,
    DeleteUserDialog,
    DxKeyboardNavigation,
    DxExport,
    GeneralFilter,
  },
  props: ["data", "win", "type"],
  data: () => ({
    currency: JSON.parse(localStorage.getItem('branch')).Currency,
    ID_Branch: JSON.parse(localStorage.getItem('branch')).ID_Branch,
    itemQtyPattern: /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/i,
    showBillPatient: false,
    useData: {},
    showServicesToAdd: false,
    showProductsToAdd: false,
    servicesToBill: [],
    productsToBill: [],
    servicesToAdd: [],
    productsToAdd: [],
    filterProducts: {
        filter: null
    },
    searchToBill: {
        filter: null
    },
    togglehide1: true,
    togglehide2: true,
    togglehide3: true,
    warehouses: [],
    selectedWarehouse: null,
    customer: {},
    print: {
      show: false,
      data: [],
    },
    alert: {
      type: "success",
      show: false,
      header: "",
      body: "",
    },
    date: "",
    valid: false,
    //useData: null,
    url: null,
    patientinfo: [],
    weightunit: '',
    weight: '',
    medicationsHeader: [],
    medication: [],
    loading: false,
    plansDialog: false,
    plan: {},
    showComments: false,
    Comments: null,
    medicationDialog: false,
    deleteDialog: false,
    id_user_login: null,
    deleteHeader: null,
    rightTableUniqueParameter: "ID_Plan_Perameter",
    showAllMedication: false,
    dataToshow: null,
    newTable: [],
    reloadMed: 0,
    items: [
      {
        ID: "1",
        Name: "Day",
        NameESP: "Día",
      },
      {
        ID: "2",
        Name: "Week",
        NameESP: "Semana",
      },
      {
        ID: "3",
        Name: "Month",
        NameESP: "Mes",
      },
      {
        ID: "4",
        Name: "Year",
        NameESP: "Año",
      },
    ],
    showMedicalData: false,
    showVacc: false,
    showhistory: false,
    search: {},
    medicationChecked: false,
    periods: [
      { id: 0, name: '1 Semanas', value: '1 Week' },
      { id: 1, name: '2 Semanas', value: '2 Week' },
      { id: 2, name: '3 Semanas', value: '3 Week' },
      { id: 3, name: '1 Mes', value: '1 Month' },
      { id: 4, name: '3 Meses', value: '3 Month' },
      { id: 5, name: '4 Meses', value: '4 Month' },
      { id: 6, name: '6 Meses', value: '6 Month' },
      { id: 7, name: '1 Año', value: '1 Year' }
    ],
  }),
  computed: {
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    columnWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '150px':'auto';
    },
  },
  async mounted() {
    this.$store.dispatch("rolesUser/getAllRoles");
    if (this.data) {
      Object.keys(this.data).map((el) => {
        Vue.set(this.patientinfo, el.toLowerCase(), this.data[el]);
      });
      this.url = this.$store.getters.getBackendUrl + "/public" + this.data.ProfilePicPath;
      this.plan.Weight = this.data.Weight;
      this.branchConfig = JSON.parse(localStorage.getItem("branch"));
      if(this.branchConfig?.weightunit) this.weightunit = this.branchConfig.weightunit;
      if(this.data?.weightunit) this.weightunit = this.data.weightunit;
    }

    const localparams = JSON.parse(localStorage.getItem("localparams")) || null;
    if (localparams && localparams.weightunit) this.weightunit = localparams.weightunit;

    if(this.plan && this.plan.Weight.includes('Kg')) this.weightunit = 'Kg';
    if(this.plan && this.plan.Weight.includes('Lb')) this.weightunit = 'Lb';

    if(this.plan.Weight && this.plan.Weight.includes(this.weightunit)) {
      this.weight = this.plan.Weight.slice(0, -2).replace(' ', '');
    } else {
      this.weight = this.plan.Weight.replace(' ', '');
    }

    this.id_user_login = JSON.parse(localStorage.getItem("user")).id;
    await this.getHeaderData();
    this.useData = JSON.parse(localStorage.getItem("user"));
    this.search.ID_Patient = this.data.ID_Patient;
    await this.getMedicationTemplate();
    this.customer.ID_Customer = this.data.ID_Customer;
    console.log('customer', this.customer);
    //this.useData = JSON.parse(localStorage.getItem("user"));
    this.warehouses = await this.$API.warehouse.getWarehousesFiltered({ isPatient: true });
    this.filterProducts.business = this.useData.businessid;
    this.filterProducts.branch = this.useData.branch;
    const found = this.warehouses.find((wh) => wh.Active == true && wh.ID_Branch == this.ID_Branch); 
    this.selectedWarehouse = found ? found.ID_Warehouse : (this.warehouses.length == 0 ? 0 : this.warehouses[0].ID_Warehouse);
    //this.selectedWarehouse = this.warehouses.length == 0 ? 0 : this.warehouses[0].ID_Warehouse;
    this.filterProducts.warehouse = this.selectedWarehouse;    
    await this.getServices();
    await this.getProducts();
    await this.getDefaultServices();
  },
  watch: {
    date: {
      async handler() {
        this.medication = await this.manageNextDate(this.medication);
      }
    },
    servicesToAdd: {
        deep: true,
        immediate: true,
        handler(newVal) {
          this.showServicesToAdd = newVal.length !== 0;
          newVal.forEach(service => {
            if (service.Price !== undefined) {
              service.UnitPrice = service.Price;
            }
          });
        }
    },
    productsToAdd: {
        deep: true,
        immediate: true,
        handler() {
            if(this.productsToAdd.length !== 0) {
                this.showProductsToAdd = true;
            }
            else {
                this.showProductsToAdd = false;
            }
        }
    },
  },
  methods: {
    totalXQuantity( { Price, quantity } ) {
        return `${this.currency}${ numberWithCommas( parseFloat( Price * quantity ).toFixed( 2 ) ) }`
    },
    async handleSelectWarehouse() {
        this.loading = true;
        this.filterProducts.warehouse = this.selectedWarehouse;
        await this.getProducts();
        this.$refs.werehouseRef.blur();
        this.loading = false;
    },
    addService(data) {
        const isRepetitive = this.servicesToAdd.find((service) => service.ID_Service === data.ID_Service);

        if (!isRepetitive) {
            this.servicesToAdd.push({ ...data, quantity: 1, UnitPrice: parseFloat(data.Price), unitPrice: `${this.currency}${numberWithCommas(parseFloat(data.Price).toFixed(4))}` });
        } else {
            const service = this.servicesToAdd.find(item => item.ID_Service === data.ID_Service)
            if(service) {
                service.quantity++;
            }
            console.log("Service already exists in servicesToAdd");
        }
    },
    addProduct(data) {
        const isRepetitive = this.productsToAdd.find((item) => item.ID_Item === data.ID_Item);
        if (!isRepetitive) {
            this.productsToAdd.push({ ...data, quantity: 1, UnitPrice: parseFloat(data.ItemPrice), unitPrice: `${this.currency}${numberWithCommas(parseFloat(data.ItemPrice).toFixed(4))}` });
        } else {
            const product = this.productsToAdd.find((item) => item.ID_Item === data.ID_Item);
            if(product) {
                product.quantity++;
            }
            console.log("Product already exists in productsToAdd.");
        }
    },
    deleteService(data) {
        const serviceIndex = this.servicesToAdd.findIndex((service) => service.CodeService === data.CodeService);

        if (serviceIndex !== -1) {
            this.servicesToAdd.splice(serviceIndex, 1);
        }
    },
    deleteProduct(data) {
        const index = this.productsToAdd.findIndex((item) => item.ID_Item === data.ID_Item);

        if (index !== -1) {
            this.productsToAdd.splice(index, 1);
        }
    },
    getServices() {
        this.$API.services.getAllServices(this.filterServices).then((response) => {
            this.servicesToBill = response;
        });
    },
    getProducts() {
        this.$API.products.getProductsToBillForInvoice(this.filterProducts).then((response) => {
            this.productsToBill = response;
        });
    },
    getDefaultServices() {
        this.$API.services.getDefaultServices().then((response) => {
            this.servicesDefault = response;
        });
    },
    servicesFilterHandler(response) {
        this.servicesToBill = response;
    },
    productsFilterHandler(response) {
        this.productsToBill = response;
    },
    getItemsToBeBilled() {
        this.$API.veterinarypatients.getServicesToBeBilled({ 'customer': this.data.ID_Customer })
        .then((response) => {
            this.servicesToAdd = []
            for(let i = 0; i < response.length; i++){
            this.servicesToAdd.push({ ...response[i], unitPrice: `${this.currency}${numberWithCommas(parseFloat(response[i].Price).toFixed(4))}` });
            }
        });
        this.$API.veterinarypatients.getProductsToBeBilled({ 'customer': this.data.ID_Customer }).then((res) => {
            if(res.success) {
            this.productsToAdd = [];
            for (const item of res.data) {
                this.productsToAdd.push({ ...item, quantity: item.Quantity, unitPrice: `${this.currency}${numberWithCommas(parseFloat(item.ItemPrice).toFixed(4))}`});
            }
            }
        });
    },
    async saveItemsToBeBilled() {
        this.showBillPatient = false;
        this.loading = true;

        try {
            if(this.servicesToAdd.length) {
            await this.$API.veterinarypatients.saveServicesToBeBilled({ 'customer': this.customer.ID_Customer, 'services': this.servicesToAdd })
            .then((res) => {
                console.log(res);
            })
            .catch((err) => {
                console.log(err);
                throw new Error('Ocurrio un error al guardar los servicios.');
            });
            }
            if(this.productsToAdd.length) {
            console.log(this.productsToAdd);
            
            await this.$API.veterinarypatients.saveProductsToBeBilled({ 'customer': this.customer.ID_Customer, 'products': this.productsToAdd })
            .then((res) => {
                console.log(res);
            })
            .catch((err) => {
                console.log(err);
                throw new Error('Ocurrio un error al guardar los productos.');
            });
            }
            await this.getItemsToBeBilled();
            this.loading = false;
            this.showAlert("success", "Exito", "Los datos de facturación de este paciente han sido guardados.")
        } catch (error) {
            console.log(error);
            this.loading = false;
            this.showAlert("warning", "Advertencia", "Ha ocurrido un error, por favor intentarlo nuevamente.")
        }

    },
    async billedPatientsOfCustomer() {
        this.showBillPatient = false;
        this.loading = true;

        try{
            await this.$API.veterinarypatients.saveServicesToBeBilled({'customer': this.customer.ID_Customer, 'services': this.servicesToAdd});
            await this.$API.veterinarypatients.saveProductsToBeBilled({ 'customer': this.customer.ID_Customer, 'products': this.productsToAdd });
            let responseBill = await this.$API.veterinarypatients.billedPatientsOfCustomer({ 'customer': this.customer.ID_Customer});

            this.loading = false;

            if (responseBill?.status == false) {
              this.showAlert("dangerHtml", "Advertencia", "No se puede crear el comprobante porque se encontraron los siguientes errores: <br/><br/>" + responseBill.message)  
              return
            }

            this.showAlert("success", "Exito", `Se ha realizado la factura de los ${this.servicesToAdd.length && this.productsToAdd.length ? 'servicios y productos' : this.servicesToAdd.length ? 'servicios' : this.productsToAdd.length ? 'productos' : 'items' } seleccionados, podrá observarla en el módulo de POS en listo para facturar.`);
            await this.getItemsToBeBilled();        
        }
        catch(error) {
            console.log(error)
            this.loading = false
            this.showAlert("warning", "Advertencia", "Ha ocurrido un error, por favor intentarlo nuevamente.")
        }
    },

    filterHandler(response) {
      this.medicationsHeader = response;
    },
    onExporting(e) {
      printToExcel(e, "Medicamentos y Vacunas");
    },
    orderParams(array) {
      array.sort(function (a, b) {
        if (
          (a["Order"] === "" || isNaN(parseInt(a["Order"]))) &&
          b["Order"] !== "" &&
          !isNaN(parseInt(b["Order"]))
        ) {
          return 1;
        } else if (
          a["Order"] !== "" &&
          !isNaN(parseInt(a["Order"])) &&
          (b["Order"] === "" || isNaN(parseInt(b["Order"])))
        ) {
          return -1;
        } else if (
          (a["Order"] === "" || isNaN(parseInt(a["Order"]))) &&
          (b["Order"] === "" || isNaN(parseInt(b["Order"])))
        ) {
          return 0;
        } else if (parseInt(a["Order"]) === parseInt(b["Order"])) {
          return 0;
        } else {
          return parseInt(a["Order"]) < parseInt(b["Order"]) ? -1 : 1;
        }
      });
      return array;
    },
    changeWeight(e) {
      this.plan.Weight = e.replace(' ', '');
      console.log('weigth', this.plan.Weight);
    },
    switchWeightUnit(e) {
      this.weightunit = e;
      console.log(this.weightunit);
    },
    setRowRecordType(row, reminder, selected) {
      const isExistingRecord = this.rightTableUniqueParameter === "ID_VPMP";
      if (isExistingRecord && !selected) return;

      this.$set(row, "checkbox", selected);
      if (selected) this.$set(row, "IsReminder", reminder);
      this.checkCheckboxes();

      if (isExistingRecord && selected) {
        this.UpdateRow({ data: row });
      }
    },
    isReminderValue(value) {
      return value === true || Number(value) === 1;
    },
    closeAlert() {
      this.alert.show = false;
    },
    acceptAlert() {
      this.alert.show = false;
      if (this.alert.options == "ConfirmDelete") {
        this.deleteVeterinaryHeader(this.deleteHeader);
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    async closePlan(e) {
      this.plan = e;
      this.plansDialog = false;
      if (this.plan.ID_Medication_Plan) {
        this.loading = true;
        let data = {
          id: this.plan.ID_Medication_Plan,
          ID_Business: JSON.parse(localStorage.getItem("user")).businessid || "",
          ID_Branch: JSON.parse(localStorage.getItem("user")).branch || "",
        };
        this.$API.veterinarymedication
          .showParametersByPlanID(data)
          .then(async (response) => {
            let data = [];
            data.push(...response);
            data.forEach((el) => {
              el.checkbox = true;
              el.methods = "insert";
              el.ID_VPMP = Math.random().toString(36).substr(2, 9);
            });
            this.medication = await this.manageNextDate(data);
            this.orderParams(this.medication);

            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
            this.showAlert("danger", "Error", "Error al cargar los datos");
          })
          .finally(() => {
            this.medicationChecked = false;
          });
      }
    },

    async closeMedicPopUp(e) {
      e.map((el) => {
        if (el.checkbox == true && !this.medication.some(item => item.ID_Medicine == el.ID_Medicine))
          if (this.medication.indexOf(el) == -1)
            this.medication.push({
              ...el,
              methods: "insert",
              ID_VPMP: Math.random().toString(36).substr(2, 9),
              checkbox: false,
              IsReminder: false,
            });
      });
      this.medication = await this.manageNextDate(this.medication);
      this.medicationDialog = false;
      this.reloadMed++;
      this.checkCheckboxes();
    },

    SaveMedication() {
      this.loading = true;
      let exist = false;
      //check if exist some medication in the same day
      console.log("HEADER DE MED")
      console.log(this.medicationsHeader)
      for (let x of this.medicationsHeader) {
        if (x.MedicationsDate == this.date) {
          exist = x;
        }
      }
      if (exist) {
        this.showAlert(
          "warning",
          "Error",
          "Ya existe un plan de medicación para la fecha seleccionada"
        );
        this.getVeterinaryDetails(exist);
        this.loading = false;
        return;
      }

      for (let x of this.medication) {
        if (x.checkbox) {
            let WeightTmp = ''
            if(this.plan.Weight && this.weightunit) WeightTmp = this.plan.Weight.concat(' ', this.weightunit);
            let body = {
              ID_Medication_Plan: x.ID_Medication_Plan,
              ID_Patient: this.patientinfo.id_patient,
              ID_Medicine: x.ID_Medicine,
              MedicationsDate: this.date,
              Medicine: x.Medicine,
              PeriodTime: x.PeriodTime,
              PeriodUnit: x.PeriodUnit,
              NextTime: x.NextTime,
              Comment: this.plan.Comment,
              ID_User_Insert: this.id_user_login,
              ItemType: x.ItemType,
              IsReminder: x.IsReminder === true || Number(x.IsReminder) === 1,
              Order: x.Order,
              Weight: WeightTmp,
          };
          console.log('cuerpe',body);
          this.$API.veterinarymedication.addVeterinaryMedicationParameter(body).then(
            () => {
              this.showAlert(
                "success",
                "Exito",
                "Se ingresaron datos de un medicamento del plan registrado."
              );

              this.loading = false;
              this.resetData();
              this.getHeaderData();
            },
            (err) => {
              console.log(err);
              this.showAlert(
                "danger",
                "Error",
                "No se pudo ingresar datos de un medicamento del plan registrado."
              );
              this.loading = false;
            }
          )
          .finally(() => {
            this.checkCheckboxes()
          });
        }
      }
    },

    async manageNextDate(e) {
      for (let x = 0; x < e.length; x++) {
        const splittedDate = this.plan.MedicationsDate.split( '/' );
        e[x].NextTime = await this.moment( `${splittedDate[2]}${splittedDate[1]}${splittedDate[0]}`, "YYYYMMDD" )
          .add(e[x].PeriodTime, e[x].PeriodUnit)
          .format("DD/MM/YYYY");
      }
      return Promise.all(e);
    },

    resetData() {
      this.medication = [];
      this.rightTableUniqueParameter = "ID_Plan_Perameter";
      this.plan = {};
      
      this.plan.Weight = this.data.Weight;
      this.branchConfig = JSON.parse(localStorage.getItem("branch"));
      if(this.branchConfig?.weightunit) this.weightunit = this.branchConfig.weightunit;
      if(this.data?.weightunit) this.weightunit = this.data.weightunit;

      const localparams = JSON.parse(localStorage.getItem("localparams")) || null;
      if (localparams && localparams.weightunit) this.weightunit = localparams.weightunit;
      if(this.plan && this.plan.Weight.includes('Kg')) this.weightunit = 'Kg';
      if(this.plan && this.plan.Weight.includes('Lb')) this.weightunit = 'Lb';
      if(this.plan.Weight && this.plan.Weight.includes(this.weightunit)) {
        this.weight = this.plan.Weight.slice(0, -2).replace(' ', '');
      } else {
        this.weight = this.plan.Weight.replace(' ', '');
      }

      this.date = this.moment().format("DD/MM/YYYY");
      this.plan.MedicationsDate = this.date;
      this.newTable = [];

      this.getMedicationTemplate();
    },

    DeleteRow(row) {
      this.loading = true;
      this.$API.veterinarymedication
        .deleteVeterinaryMedicationPerameter(row.data.ID_VPMP)
        .then(
          () => {
            //   this.$toasted.info("Se elimino el medicamento seleccionado");
            this.loading = false;
          },
          (err) => {
            console.log(err);
            this.loading = false;
          }
        );
    },
    handleRowDeleting(e) {
      if (this.rightTableUniqueParameter == "ID_VPMP") {
        if (e.data.methods != "insert") {
          this.newTable.push({ data: { ...e.data }, methods: "delete" });
        }
      }
    },
    deleteMedicationRow(row) {
      this.handleRowDeleting({ data: row });
      const index = this.medication.indexOf(row);
      if (index !== -1) this.medication.splice(index, 1);
      this.checkCheckboxes();
    },

    getHeaderData() {
      //console.log("ejecutado",this.data.ID_Patient);
      this.$API.veterinarymedication
        .getVeterinaryMedicationHeaderHistory(this.data.ID_Patient)
        .then(
          (res) => {
            this.medicationsHeader = res;
            //console.log("esto traje",res);

            if (this.$store.state.vetPatientData.dataLabs) {
              let date = this.$store.state.vetPatientData.dataLabs;

              let value = null;
              this.$store.commit("vetPatientData/cleanData");
              this.medicationsHeader.forEach((element) => {
                if (element.MedicationsDate == date) {
                  value = element;
                }
              });
              if (value) {
                this.getVeterinaryDetails(value);
              }
            }
          },
          (err) => {
            console.log(err);

            //this.$toasted.error(err.message);
          }
        );
    },

    getVeterinaryDetails(data) {
      this.dataToshow = data;
      this.loading = true;

      this.plan = data;
      if(this.plan.Weight?.includes('Kg')) {
        this.weightunit = 'Kg';
        this.weight = this.plan.Weight.slice(0, -2).replace(' ', '');
      }
      else if(this.plan.Weight?.includes('Lb')) {
        this.weightunit = 'Lb';
        this.weight = this.plan.Weight.slice(0, -2).replace(' ', '');
      }
      else {
        this.weightunit = '';
        this.weight = this.plan.Weight?.replace(' ', '');
      }

      const body = {
        ID_Medication_Plan: data.ID_Medication_Plan,
        ID_Patient: data.ID_Patient,
        MedicationsDate: data.MedicationsDate,
      };
      this.$API.veterinarymedication
        .getVeterinaryPerameterOfPlans(body)
        .then(
          (res) => {
            this.rightTableUniqueParameter = "ID_VPMP";
            res.map((data) => {
              data.checkbox = true;
              data.FullPeriod = ''
            });
            this.medication = res;
            this.plan.Comment = res[0].Comment;
            this.plan.Prev = res[0].Comment;
            this.plan.Weight = res[0].Weight;
            this.orderParams(this.medication);
            this.date = this.medication[0].MedicationsDate;
            if(this.plan.Weight.includes('Kg')) {
              this.weightunit = 'Kg';
              this.weight = this.plan.Weight.slice(0, -2).replace(' ', '');
            }
            else if(this.plan.Weight.includes('Lb')) {
              this.weightunit = 'Lb';
              this.weight = this.plan.Weight.slice(0, -2).replace(' ', '');
            }
            else {
              this.weightunit = '';
              this.weight = this.plan.Weight.replace(' ', '');
            }
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            this.showAlert(
              "danger",
              "Error",
              "No se pudo obtener los datos de los planes de medicamentos."
            );
            console.log(err);
            // this.$toasted.error(err.message);
          }
        )
        .catch(() => {
          this.loading = false;
          this.getHeaderData();
        });
    },

    deleteVeterinaryHeader(data) {
      this.loading = true;
      const body = {
        ID_Medication_Plan: data.ID_Medication_Plan,
        ID_Patient: data.ID_Patient,
        MedicationsDate: data.MedicationsDate,
      };
      this.$API.veterinarymedication.deleteVeterinaryMedicationParameterBulk(body).then(
        () => {
          this.showAlert(
            "success",
            "Exito",
            "Se elimino el plan de medicamentos seleccionado."
          );
          this.deleteDialog = false;
          this.getHeaderData();
          this.resetData();
          this.loading = false;
        },
        (err) => {
          this.showAlert(
            "danger",
            "Error",
            "No se pudo eliminar el plan de medicamentos seleccionado."
          );
          console.log(err);
          // this.$toasted.error(err.message);
          this.loading = false;
        }
      );
    },
    async handleMed() {
      this.medication = await this.manageNextDate(this.medication);
    },
    async UpdateRow(e) {
      this.medication = await this.manageNextDate(this.medication);
      if (this.rightTableUniqueParameter == "ID_VPMP") {
        if (e.data.methods != "insert") {
          this.newTable.push({ data: { ...e.data }, methods: "update" });
        }
      }
      this.orderParams(this.medication);
    },

    updateVeterinaryParameterData() {
      if(this.plan.Weight) {
        if(!this.plan.Weight.includes('Lb') && !this.plan.Weight.includes('Kg')) {
          this.plan.Weight = this.plan.Weight.concat(' ', this.weightunit);
        } 
        else if(!this.plan.Weight.includes(this.weightunit)) {
          const newValue = this.plan.Weight.slice(0, -3);
          this.plan.Weight = newValue.concat(' ', this.weightunit);
          console.log(this.plan.Weight);
        }
      } 
      this.plan.ID_User_Insert = this.id_user_login;
      this.medication.forEach((el) => {
        console.log("element", el, el.methods, el.checkbox);
        if (el.methods == "insert" && el.checkbox) {
          this.newTable.push({
            data: { ...el },
            methods: "insert",
            Comment: this.plan.Comment,
            Weight: this.plan.Weight,
            IsReminder: el.IsReminder === true || Number(el.IsReminder) === 1,
          });
        }
      });
      if (this.newTable.length == 0) {
        this.showAlert(
          "danger",
          "Advertencia",
          "No se han realizado cambios en el plan de medicamentos."
        );
        return;
      }
      if (this.plan.Comment != this.plan.Prev) {
        this.plan.NewComment = this.plan.Comment;
      }
      this.$API.veterinarymedication
        .updateVeterinaryMedicationPerameter(this.plan, this.newTable)
        .then(
          () => {
            this.showAlert(
              "success",
              "Exito",
              "Se actualizo el plan de medicamentos seleccionado."
            );
            this.getVeterinaryDetails(this.dataToshow);
            this.newTable = [];
            this.loading = false;
          },
          (err) => {
            this.showAlert(
              "danger",
              "Error",
              "No se pudo actualizar el plan de medicamentos seleccionado."
            );
            console.log(err);
            this.loading = false;
            this.newTable = [];
          }
        );
    },

    setPeriod(data){
      const { data: innerData } = data
      const { ID_VPMP } = innerData
      const words = innerData.FullPeriod.split(' ');
      this.medication.find((med) => {
        if(med.ID_VPMP == ID_VPMP){
          med.PeriodTime = words[0]
          med.PeriodUnit = words[1]
        }
      })
      this.UpdateRow(data);
    },

    getMedicationTemplate(){
      const data = {
        species: this.patientinfo.species
      }
      this.loading = true;
      this.$API.veterinarypatients.findmedicationstemplate( data ).then((response) => {
        this.medication = response;
        response.map((med) => {
          med.ID_VPMP = new Date(new Date() - Math.random()*(1e+12))
          med.ID_Medicine = parseInt(med.ID_Medicine)
          med.Order = parseInt(med.Order)
          med.ID_Medication_Plan = undefined
          med.checkbox = false;
          med.methods = "insert";
          med.FullPeriod = `${med.PeriodTime} ${med.PeriodUnit}`
        })
        //console.log(this.medication)
        
      }).finally(() => {
        this.loading = false;
        this.rightTableUniqueParameter = "ID_Plan_Perameter";
        this.UpdateRow();
      })
    },

    getSelectedRow(data){
      console.log(data)
      this.checkCheckboxes();
    },

    checkCheckboxes() {
      this.medicationChecked = this.medication.some(({ checkbox }) => checkbox) && this.medication.length > 0;
      console.log("el check es", this.medicationChecked)
    },

    // Método para actualizar el peso cuando se actualiza el paciente
    updatePatientWeight(payload) {
      console.log('📥 VeterinaryMedications recibiendo actualización de peso:', payload);
      
      if (payload && payload.veterinarypatient && payload.veterinarypatient.Weight) {
        const newWeight = payload.veterinarypatient.Weight;
        
        // Determinar la unidad de peso
        if (newWeight.includes('Kg')) {
          this.weightunit = 'Kg';
        } else if (newWeight.includes('Lb')) {
          this.weightunit = 'Lb';
        }
        
        // Extraer el valor numérico del peso
        if (newWeight.includes(this.weightunit)) {
          this.weight = newWeight.slice(0, -2).replace(' ', '');
        } else {
          this.weight = newWeight.replace(' ', '');
        }
        
        // Actualizar el objeto plan con el nuevo peso
        this.plan.Weight = newWeight;
        
        console.log('✅ Peso actualizado en VeterinaryMedications:', {
          weight: this.weight,
          weightunit: this.weightunit,
          planWeight: this.plan.Weight
        });
      } else {
        console.warn('⚠️ Payload inválido para actualización de peso en VeterinaryMedications');
      }
    }

  },
};
</script>

<style scoped>
.btndisable {
    background-color: #41464c !important;
    color: white;
}
.btndisable2 {
    background-color: #1976d2 !important;
    color: white;
}

.btnblack {
  background-color: rgba(60, 60, 60, 1) !important;
  color: white !important;
}
.tabs {
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white;
}

.infopatient {
  margin-top: 5%;
}
.record-type-heading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  min-height: 24px;
  font-weight: 500;
}
.record-type-cell {
  display: flex;
  justify-content: center;
}
.history-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}
.history-dialog-actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.btn-save-disabled.v-btn.v-btn--disabled.v-btn--has-bg,
.theme--dark.btn-save-disabled.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #bdbdbd !important;
  color: #ffffff !important;
}
.btn-add {
  background-color: #3498db !important;
  color: white;
}
.btnsave {
  background-color: #00a178 !important;
  color: white;
}
.btncleanVet {
  background-color: #f29d35 !important;
  color: white;
}
.btndelete {
  background-color: #e3191e !important;
  color: white;
}
.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}
.btnblue {
  background-color: #1976d2 !important;
  color: white;
}
.tabsB {
  width: 100%;
  padding: 10px;
  background-color: #1976d2;
  color: white;
  border-radius: 15px;
  border-style: solid;
  border-color: black;
  border-width: 1px;
}
.tabsB:hover {
  cursor: pointer;
}
.box {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  background-color: white;

  border-radius: 15px;
}

/* .v-list {
  z-index: 10 !important;
  position: relative;
} */
</style>
